<div *ngIf="errorMessage && !errorCode; else genericMessage">{{ errorMessage }}</div>
<ng-template #genericMessage>
  <div
    [innerHTML]="
      'GenericApiErrorComponent:ErrorMessage'
        | translate
          : {
              contact_number_general: (customisableVariables | async).contact_number_general,
              generalContactNumber: (customisableVariables | async).contact_number_general,
              generalContactNumberHidden: (customisableVariables | async).contact_number_general ? '' : 'hidden',
              separatorHidden:
                (customisableVariables | async).contact_number_general &&
                (customisableVariables | async).toll_free_contact_number
                  ? ''
                  : 'hidden',
              toll_free_contact_number: (customisableVariables | async).toll_free_contact_number,
              tollFreeContactNumber: (customisableVariables | async).toll_free_contact_number,
              tollFreeContactNumberHidden: (customisableVariables | async).toll_free_contact_number ? '' : 'hidden'
            }
    "
  ></div>
</ng-template>
